<cs-icon-button
  class="btn-close"
  iconType="icon"
  icon="fi-x"
  color="secondary"
  size="12"
  (buttonClick)="close()"
></cs-icon-button>

<div class="wrapper">
  <div class="heading">TIMEOUT</div>
  <div class="cont">
    @if (state === 'timeout') {
      <!-- Timeout 状态 -->
      <div class="description">Your account is on a timeout for {{ this.data.period }} days</div>
      <div class="time-wrap">
        <div class="time-info">
          <div class="time-row">
            <span class="time-label">Start time</span>
            <span class="time-value">{{ startTime | mdate: 'DD/MM/YYYY, HH:mm' }}</span>
          </div>
          <div class="time-row">
            <span class="time-label">End time</span>
            <span class="time-value">{{ endTime | mdate: 'DD/MM/YYYY, HH:mm' }}</span>
          </div>
        </div>

        <app-countdown-limit [until]="endTime / 1000" (countdownComplete)="onCountdownComplete()"></app-countdown-limit>
      </div>

      <div class="reopen-section">
        @if (!isTimeoutComplete) {
          <span class="reopen-text">
            Want to reopen early? There's a 24-hour cooling-off period before you can log in.
          </span>
        }
        <cs-button
          [label]="isTimeoutComplete ? 'Continue to Login' : 'Reopen Account'"
          size="large"
          color="primary"
          [loading]="isLoading"
          (buttonClick)="onReopenAccount()"
        ></cs-button>
      </div>

      <span class="contact-text">
        If you want to increase your timeout or make it permanent, please contact customer service support via our
        <span class="chat-link" (click)="toService()">Live Chat</span>
      </span>
    } @else {
      <!-- Reopen 状态 -->
      <div class="description">
        Your account is in a cooling-off period. You will be able to access your account in:
      </div>

      <app-countdown-limit
        [until]="endTime / 1000"
        [showDays]="false"
        (countdownComplete)="onCountdownComplete()"
      ></app-countdown-limit>
      @if (isReopenComplete) {
        <cs-button label="Continue to Login" size="large" color="primary" (buttonClick)="onReopenAccount()"></cs-button>
      }
      <span class="contact-text">
        If you want to increase your timeout or make it permanent, please contact customer service support via our
        <span class="chat-link" (click)="toService()">Live Chat</span>
      </span>
    }
  </div>
</div>
